import React, { Fragment } from "react";
import { Grid } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import { ReactSVG } from "react-svg";
import styles from "./webinar.module.scss";
import { WebnerForm } from "./components";

export const UKApplicationWeekPage = () => {
  return (
    <Fragment>
      <section className={`${styles.section_hero} ${styles.application_week}`}>
        <div className="container">
          <Grid container spacing={{ xs: 3, sm: 3, md: 6 }} alignItems="center">
            <Grid item xs={12} sm={12} md={6}>
              <div className={styles.heading_wrapper}>
                <h1 className={`${styles.heading}`}>
                  UK
                  <span className={"mark color-orange"}> Application Week</span>
                </h1>
                <p className={`${styles.sub_text} `}>
                  UniSearch’s key goal is to empower each of our students to
                  take control of their study abroad journey and tailor it to
                  their distinct needs. Our UK Application Week is designed to
                  help you do just that! Through one-to-one sessions with our
                  study abroad experts, you receive personalised attention and
                  support for your university applications, setting you firmly
                  on track to make your higher education dreams come true.
                </p>

                <div className={styles.time_wrapper}>
                  <div className={styles.time_card}>
                    <ReactSVG
                      src={getAssets("assets/images/webinar/calendar.svg")}
                    />
                    <div className={styles.time_text}>
                      <div className={styles.time_text_bold}>Date</div>
                      <div className={styles.time_text_normal}>
                        30<sup>th</sup> May - 4<sup>th</sup> June, 2022
                      </div>
                    </div>
                  </div>
                  <div className={styles.time_card}>
                    <ReactSVG
                      src={getAssets("assets/images/webinar/stopwatch.svg")}
                    />
                    <div className={styles.time_text}>
                      <div className={styles.time_text_bold}>Time</div>
                      <div className={styles.time_text_normal}>
                        10:30 am to 5:00 pm
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.btn_wrapper}>
                  <a href={"#form"} className={`btn btn-secondary btn-bg`}>
                    Book Now
                  </a>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div className={styles.hero_image_wrapper}>
                <img
                  src={getAssets(
                    "assets/images/webinar/webinar-uk-application-week.png"
                  )}
                  alt="UK Application Week"
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
      <div className={styles.description_and_form_section_wrapper}>
        {/* Section Description */}
        <section>
          <div className="container">
            <div className={styles.description_wrapper}>
              <div className={styles.description_title_wrapper}>
                <h2
                  className={`${styles.description_title} ${styles.custom_desc_title}`}
                >
                  During the{" "}
                  <span className="color-orange">
                    UniSearch UK Application Week,
                  </span>{" "}
                  our study abroad experts will help you:
                </h2>
              </div>
              <div className={styles.description_card_wrapper}>
                <div className={styles.margin_top_60}>
                  <div className={styles.description_card_segment}>
                    <div
                      className={`${styles.description_card} ${styles.orange}`}
                    >
                      <ReactSVG
                        src={getAssets("assets/images/webinar/list.svg")}
                      />

                      <div className={styles.description_card_text}>
                        Shortlist your right-fit universities and programs
                      </div>
                    </div>
                    <div className={`${styles.description_card} ${styles.red}`}>
                      <ReactSVG
                        src={getAssets("assets/images/webinar/analysis.svg")}
                      />

                      <div className={styles.description_card_text}>
                        Walk through application steps and procedures
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.description_card_segment} ${styles.align_top}`}
                >
                  <div className={`${styles.description_card} ${styles.blue}`}>
                    <ReactSVG
                      src={getAssets("assets/images/webinar/documents.svg")}
                    />

                    <div className={styles.description_card_text}>
                      Compile and craft robust applications
                    </div>
                  </div>
                  <div
                    className={`${styles.description_card} ${styles.violet}`}
                  >
                    <ReactSVG
                      src={getAssets("assets/images/webinar/hat.svg")}
                    />

                    <div className={styles.description_card_text}>
                      Explore scholarship and funding opportunities
                    </div>
                  </div>
                </div>

                <div className={styles.margin_top_60}>
                  <div className={styles.description_card_segment}>
                    <div
                      className={`${styles.description_card} ${styles.green}`}
                    >
                      <ReactSVG
                        src={getAssets(
                          "assets/images/webinar/job-search-green.svg"
                        )}
                      />

                      <div className={styles.description_card_text}>
                        Discover post-study opportunities in the UK
                      </div>
                    </div>
                    <div
                      className={`${styles.description_card} ${styles.orange}`}
                    >
                      <ReactSVG
                        src={getAssets("assets/images/webinar/passport.svg")}
                      />

                      <div className={styles.description_card_text}>
                        Know more about the UK Student visa processes
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section form */}
        <WebnerForm
          title="Sign Up for the UniSearch UK Application Week"
          subTitle="Ready to take the first step in your UK study abroad adventure? Share your details with us below, and we will be in touch with you shortly!"
          subject={"UK Application Week"}
          subjectHTML={`
            <div
              style="
                font-size: 22px;
                font-weight: 600;
                line-height: 36px;
                padding: 0 50px;
                text-align: center;
                margin: 0 !important;
              "
            >
            Your Registration Was Successful! | UniSearch <span style="color: #f47f20">UK Application Week</span>
            </div>
        `}
          bodyHTML={`
            <div style="padding: 0 50px; font-size: 12px">
              <p style="line-height: 1.8">Hi --NAME--,</p>
              <p style="line-height: 1.8">
              Thank you for signing up for the UniSearch UK Application Week! 
              </p>
              <p style="line-height: 1.8">
              Our commitment to make every stage of studying abroad accessible for every student is at the heart of what we do. This week-long event is created to help students access the one-to-one support they seek when navigating university applications and achieving the highest chances of admissions success, and we’re thrilled to have you be a part of it! 
              </p>
              <p style="line-height: 1.8">
              <span style="font-weight:bold">Event:</span> UniSearch UK Application Week <br/>
              <span style="font-weight:bold">Date:</span> 30 May - 4 June, 2022 <br/>
              <span style="font-weight:bold">Time:</span> 10:00 am - 5:00 pm <br/>
              </p>
              <p style="line-height: 1.8">
              A UniSearch representative will be in touch with you shortly to book your preferred appointment date and time.
              </p>
              <p style="line-height: 1.8">
                We look forward to seeing you soon! <br />
                UniSearch
              </p>
            </div>
        `}
        />
      </div>
    </Fragment>
  );
};

export default UKApplicationWeekPage;
